export const getKey = (type: string, activeNow: string) => {
  switch (activeNow) {
  case 'picture':
    return `${type}_FOR_PICTURE`
  case 'video':
    return `${type}_FOR_VIDEO`
  case 'qa':
    return `${type}_FOR_QA`
  default:
    throw new Error('unknown active index')
  }
}
